export const styleConst = {
  primaryColor: "#b60732",
  pgbackground: "#fffdfd",
  fontcolor: "#242424",
  transparentBackground: "#24242428",
};
